import validation from '../../../validation/index.js'
import rules from '../../../validation/rules/index.js'

const postBodyRules = { token: rules.string().required() }

const postBody = {
  rules: postBodyRules,
  schema: validation.schema(postBodyRules),
}

// eslint-disable-next-line import/prefer-default-export
export const post = { body: postBody }
